// src/components/Board.js
import React from "react";
import { format, toZonedTime } from "date-fns-tz";
import "./board.css";

// Función para mezclar el array de manera aleatoria
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

// Función para ajustar la fecha a la zona horaria UTC-3 y formatearla
const formatDateToUTCMinus3 = (dateStr) => {
  // Definir la zona horaria
  const timeZone = "America/Argentina/Buenos_Aires";

  // Convertir la fecha en UTC a la zona horaria UTC-3
  const zonedDate = toZonedTime(dateStr, timeZone);

  // Formatear la fecha como YYYY-MM-DD HH:MM:SS
  return format(zonedDate, "yyyy-MM-dd HH:mm:ss", { timeZone });
};

const Board = ({ data }) => {
  // Mezclamos el array de datos para obtener un orden aleatorio
  const shuffledData = shuffleArray([...data]);

  // Obtenemos los primeros 10 resultados
  const displayedData = shuffledData.slice(0, 10);

  // Si hay menos de 10 resultados, llenamos con filas vacías
  const emptyRows = Array.from({ length: 10 - displayedData.length });

  return (
    <div className="board-container" lang="es">
      <table className="board-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Categoria</th>
            <th>Tipo</th>
            <th>Prioridad</th>
            <th>Ultima vez actualizado</th>
            <th>A la espera de</th>
            <th>Grupo</th>
          </tr>
        </thead>
        <tbody>
          {displayedData.map((item, index) => (
            <tr key={index} className={item.filtered ? "filtered-row" : ""}>
              <td>{item.id}</td>
              <td>{item.request.category.label}</td>
              <td>{item.request.type.label}</td>
              <td>{item.priority.label}</td>
              <td>{formatDateToUTCMinus3(item.last_update.formatted)}</td>
              <td>
                {item.waiting_for.label} {item.waiting_for.value}
              </td>
              <td>{item.group}</td>
            </tr>
          ))}
          {emptyRows.map((_, index) => (
            <tr key={`empty-${index}`} className="empty-row">
              <td colSpan="7">No more data</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Board;
